"use strict"

import Vue from "vue"

const conf = {
  seatsLimit: 10,
  colormap: [
    "#FF824D", "#4D8BFF", "#F5BF49", "#992E99", "#38B08C", "#805326",
    "#4dc4ff", "#ff8082",  "#FFF64D", "#84919e", "#333333", "#c9ace6"],
  colormap2: [
    "#CC683E", "#3E6FCC", "#C2973A", "#802680", "#287D63", "#4D3217",
    "#3E9DCC", "#CC6668", "#CCC53E", "#59626B", "#000000", "#9C86B3"],
  subscriptionRetryInterval: 10 * 1000,
  startRecordingTimeoutMS: 30 * 1000,
}
export default conf

const methods = {
  config: () => conf,
  log: console.log,
  getColor: (i) => conf.colormap[i],
  getColor2: (i) => conf.colormap2[i],
}
Vue.mixin({methods})
